import { render } from "./CodeIde.vue?vue&type=template&id=72e00466"
import script from "./CodeIde.vue?vue&type=script&lang=js"
export * from "./CodeIde.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__